/**
 * ![lightGreen 50](https://mui.com/static/colors-preview/lightGreen-50-24x24.png) ![lightGreen 100](https://mui.com/static/colors-preview/lightGreen-100-24x24.png) ![lightGreen 200](https://mui.com/static/colors-preview/lightGreen-200-24x24.png) ![lightGreen 300](https://mui.com/static/colors-preview/lightGreen-300-24x24.png) ![lightGreen 400](https://mui.com/static/colors-preview/lightGreen-400-24x24.png) ![lightGreen 500](https://mui.com/static/colors-preview/lightGreen-500-24x24.png) ![lightGreen 600](https://mui.com/static/colors-preview/lightGreen-600-24x24.png) ![lightGreen 700](https://mui.com/static/colors-preview/lightGreen-700-24x24.png) ![lightGreen 800](https://mui.com/static/colors-preview/lightGreen-800-24x24.png) ![lightGreen 900](https://mui.com/static/colors-preview/lightGreen-900-24x24.png) ![lightGreen A100](https://mui.com/static/colors-preview/lightGreen-A100-24x24.png) ![lightGreen A200](https://mui.com/static/colors-preview/lightGreen-A200-24x24.png) ![lightGreen A400](https://mui.com/static/colors-preview/lightGreen-A400-24x24.png) ![lightGreen A700](https://mui.com/static/colors-preview/lightGreen-A700-24x24.png)
 */
const lightGreen = {
  /**
   * Preview: ![lightGreen 50](https://mui.com/static/colors-preview/lightGreen-50-24x24.png)
   */
  50: '#f1f8e9',
  /**
   * Preview: ![lightGreen 100](https://mui.com/static/colors-preview/lightGreen-100-24x24.png)
   */
  100: '#dcedc8',
  /**
   * Preview: ![lightGreen 200](https://mui.com/static/colors-preview/lightGreen-200-24x24.png)
   */
  200: '#c5e1a5',
  /**
   * Preview: ![lightGreen 300](https://mui.com/static/colors-preview/lightGreen-300-24x24.png)
   */
  300: '#aed581',
  /**
   * Preview: ![lightGreen 400](https://mui.com/static/colors-preview/lightGreen-400-24x24.png)
   */
  400: '#9ccc65',
  /**
   * Preview: ![lightGreen 500](https://mui.com/static/colors-preview/lightGreen-500-24x24.png)
   */
  500: '#8bc34a',
  /**
   * Preview: ![lightGreen 600](https://mui.com/static/colors-preview/lightGreen-600-24x24.png)
   */
  600: '#7cb342',
  /**
   * Preview: ![lightGreen 700](https://mui.com/static/colors-preview/lightGreen-700-24x24.png)
   */
  700: '#689f38',
  /**
   * Preview: ![lightGreen 800](https://mui.com/static/colors-preview/lightGreen-800-24x24.png)
   */
  800: '#558b2f',
  /**
   * Preview: ![lightGreen 900](https://mui.com/static/colors-preview/lightGreen-900-24x24.png)
   */
  900: '#33691e',
  /**
   * Preview: ![lightGreen A100](https://mui.com/static/colors-preview/lightGreen-A100-24x24.png)
   */
  A100: '#ccff90',
  /**
   * Preview: ![lightGreen A200](https://mui.com/static/colors-preview/lightGreen-A200-24x24.png)
   */
  A200: '#b2ff59',
  /**
   * Preview: ![lightGreen A400](https://mui.com/static/colors-preview/lightGreen-A400-24x24.png)
   */
  A400: '#76ff03',
  /**
   * Preview: ![lightGreen A700](https://mui.com/static/colors-preview/lightGreen-A700-24x24.png)
   */
  A700: '#64dd17',
} as const;

export default lightGreen;
